import React from "react";
import "./auth.css";
import Login from "./login";
import { Colors } from "../../Constants/colors";
import SchoolLogo from "./../../images/school-logo.png";
export enum FormType {
  LOGIN = "login",
  REGISTER = "register",
}

const AuthForm = () => {
  return (
    <div
      className="h-screen w-screen p-10 justify-center flex"
      style={{
        backgroundColor: `${Colors.White}`,
        //MIGHT NEED BACKGROUND IMAGE
      }}
    >
      <div
        className="h-full w-full md:w-3/4 rounded-lg flex flex-col md:flex-row"
        style={{
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          overflow: "hidden",
        }}
      >
        <div
          className="w-full h-1/4 md:h-full md:w-2/5 flex"
          style={{ backgroundColor: Colors.BurgundyRed }}
        >
          <div className="w-full flex justify-center">
            <img
              src={SchoolLogo}
              alt="school logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
        <div
          className="h-full w-full md:w-4/5 flex"
          style={{
            backgroundColor: `${Colors.White}`,
          }}
        >
          <div className="h-full w-full p-5">
            <div className="h-full p-2 md:p-4">
              <div>
                <h1 className="text-4xl">Welcome</h1>
                <p className="text-xs mt-1">Please login to your account</p>
              </div>

              <Login header="welcome" subHeader="test" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuthForm;
